// extracted by mini-css-extract-plugin
export default {"placementCell":"LevelPlacementsLayer_placementCell__9h47M"};